import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE_URL } from '../../../app.definitions';
import { ApiResponse } from '../../../shared/models';
import { GetSubmissionsResponse } from '../../../shared/models/responses/get-submissions-response.modal';

import { Observable } from 'rxjs';
import { SubmissionDetails } from 'ngx-esprio-shared';

@Injectable()
export class UserSubmissionsApiService {
  constructor(@Inject(API_BASE_URL) private apiBaseUrl: string, private httpClient: HttpClient) {}

  public getSubmissions(userId: string, monitoredUserId: string): Observable<ApiResponse<GetSubmissionsResponse>> {
    return this.httpClient.get<ApiResponse<GetSubmissionsResponse>>(
      `${this.apiBaseUrl}/monitoring/${userId}/${monitoredUserId}/surveys`
    );
  }

  public getSubmissionDetails(userId: string, monitoredUserId: string, submissionId: string): Observable<ApiResponse<SubmissionDetails>> {
    return this.httpClient.get<ApiResponse<SubmissionDetails>>(
      `${this.apiBaseUrl}/users/${monitoredUserId}/submissions/${submissionId}/requested-by/${userId}`
    );
  }

  public loadLatestSubmissionDetails(userId: string, monitoredUserId: string): Observable<ApiResponse<SubmissionDetails>> {
    return this.httpClient.get<ApiResponse<SubmissionDetails>>(
      `${this.apiBaseUrl}/users/${monitoredUserId}/submissions/latest/requested-by/${userId}`
    );
  }
}
